const Eth = () => {
	return (
		<svg xmlns='http://www.w3.org/2000/svg' width='100%' height='100%' viewBox='0 0 32 32' fill='none'>
			<path
				d='M16 32C24.8366 32 32 24.8366 32 16C32 7.16344 24.8366 0 16 0C7.16344 0 0 7.16344 0 16C0 24.8366 7.16344 32 16 32Z'
				fill='#627EEA'
			/>
			<path
				d='M16 0.5C24.5604 0.5 31.5 7.43959 31.5 16C31.5 24.5604 24.5604 31.5 16 31.5C7.43959 31.5 0.5 24.5604 0.5 16C0.5 7.43959 7.43959 0.5 16 0.5Z'
				stroke='white'
				strokeOpacity='0.2'
			/>
			<path d='M16.498 4V12.87L23.995 16.22L16.498 4Z' fill='white' fillOpacity='0.602' />
			<path d='M16.498 4L9 16.22L16.498 12.87V4Z' fill='white' />
			<path d='M16.498 21.968V27.995L24 17.616L16.498 21.968Z' fill='white' fillOpacity='0.602' />
			<path d='M16.498 27.995V21.967L9 17.616L16.498 27.995Z' fill='white' />
			<path d='M16.498 20.5731L23.995 16.2201L16.498 12.8721V20.5731Z' fill='white' fillOpacity='0.2' />
			<path d='M9 16.2201L16.498 20.5731V12.8721L9 16.2201Z' fill='white' fillOpacity='0.602' />
		</svg>
	);
};

export default Eth;
